exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trips-index-page__excel-export[data-v-578a85e9]{border-color:#2563eb!important;background:#2563eb!important;color:#fff!important}.trips-index-page__excel-export[data-v-578a85e9]:active,.trips-index-page__excel-export[data-v-578a85e9]:focus,.trips-index-page__excel-export[data-v-578a85e9]:hover{border-color:#1d4ed8!important;background:#1d4ed8!important;color:#fff!important}", ""]);

// exports
